<template>
    <div>
        <div id="placeholder" style="min-height:100vh;"></div>
    </div>
</template>

<script>

export default {
    props     : ['documentId', 'documentStorageLink'],
    name: 'proposal-generator-only-office',
    data() {
        return {

            docEditor: null,
        }
    },
    created() {

    },
    mounted() {

        const config = {
            document: {
                fileType: "docx",
                key: this.documentId,
                title: "Title.docx",
                url: this.documentStorageLink,
            },
            documentType: "word",
            editorConfig: {
                mode: "edit",
                callbackUrl: window.location.origin+"/only-office-callback",
            },
            height: "900px",
            type: "desktop",
            width: "100%"
        };
        this.docEditor = new DocsAPI.DocEditor("placeholder", config);
    },
    methods   :{

    },
}
</script>

